const USERNAME_REGEX = /^[a-zA-Z0-9_-]+$/;

export function normalizeUsernameInput(value: string | null | undefined): string {
  return String(value ?? '').replace(/\s+/g, '');
}

export function isValidUsername(username: string): boolean {
  const normalizedUsername = normalizeUsernameInput(username);
  return normalizedUsername.length >= 2
    && normalizedUsername.length <= 30
    && USERNAME_REGEX.test(normalizedUsername);
}
